import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  constructor(private idle: Idle, private router: Router) {}

  startWatching() {
    const sessionExpiry = localStorage.getItem('sessionExpiry');
    // if (sessionExpiry && Date.now() > parseInt(sessionExpiry)) {
    //   // this.logoutUser();
    //   return; // Session expired, no need to start idle watcher
    // }

    this.idle.setIdle(3600); // 30 seconds idle timeout for testing
    this.idle.setTimeout(5); // 5 seconds countdown before timeout
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // Detect user events like mouse, keyboard

    this.idle.onTimeout.subscribe(() => {
      // alert('Session expired due to inactivity. Logging out...');
      // this.logoutUser();
    });

    this.idle.watch();
  }

  stopWatching() {
    this.idle.stop();
  }

  logoutUser() {
    // localStorage.clear();
    // this.router.navigate(['/login']);
  }
}
